<template>
  <nav class="navbar app-navbar navbar-toggleable-md">
    <div class="d-none d-lg-flex navbar-brand-container align-items-center justify-content-start">
      <router-link class="navbar-brand logo" to="/">
        <!--<i class="i-vuestic"></i>-->
        <img :src="require('@/assets/icons/logo@1x.png')"/>
      </router-link>
    </div>

    <div class="row navbar-container">

      <div
        class="menu-icon-container d-flex align-items-center justify-content-center justify-content-lg-start col">
        <a class="menu-icon i-menu-expanded" href="#" @click.prevent="toggleSidebar(false)"
           v-if="sidebarOpened"></a>
        <a class="menu-icon i-menu-collapsed" href="#" @click.prevent="toggleSidebar(true)"
           v-else></a>
      </div>

      <!--<div-->
      <!--class="navbar-text offset-md-1 col-md-7 d-none d-lg-flex align-items-center justify-content-center">-->
      <!--{{'navbar.messageUs' | translate}}&nbsp;<a-->
      <!--href="mailto:hello@epicmax.co">hello@epicmax.co</a>-->
      <!--</div>-->
      <div class="navbar-text offset-md-1 col-md-7 d-none d-lg-flex align-items-center justify-content-center">
        <span>
          {{$t('navbar.version', {version: env.VERSION})}}
          ({{env.TIME | moment('YYYY/MM/DD HH:mm:ss')}})
        </span>
        <span v-if="config.debug" class="badge badge-danger badge-pill" style="min-width: auto;">DEV</span>
      </div>

      <!--<div
        class="col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"
        v-dropdown>
        <a class="nav-link dropdown-toggle d-flex align-items-center justify-content" href="#"
           @click.prevent="closeMenu">
          <span class="i-nav-messages notify"></span>
        </a>
        <div class="dropdown-menu">
          <div class="dropdown-menu-content">
            <a class="dropdown-item" href="#">
              <span class="ellipsis">{{ $t('messages.new', {name: 'Oleg M'})}}</span>
            </a>
            <a class="dropdown-item" href="#">
              <span class="ellipsis">{{ $t('messages.new', {name: 'Andrei H'})}}</span>
            </a>
            <div class="dropdown-item plain-link-item">
              <a class="plain-link" href="#">{{'messages.all' | translate}}</a>
            </div>
          </div>
        </div>
      </div>-->
      <div
        class="col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"
        v-dropdown.closeOnMenuClick>
        <a class="nav-link dropdown-toggle d-flex align-items-center justify-content" href="#"
           @click.prevent="closeMenu">
          <span v-if="notifications.total" class="i-nav-notification">
            <span class="badge badge-pill badge-info">{{notifications.total}}</span>
          </span>
        </a>
        <div class="dropdown-menu">
          <div class="dropdown-menu-content">
            <router-link class="dropdown-item" v-for="n in notifications.docs"
                         :to="{name: 'Notification', params: {id: n._id}}"
                         :key="n._id">
              <div class="ellipsis pt-2 pb-2" style="flex-grow: 1">
                <div>{{n.subject}}</div>
                <div style="font-size: small; opacity: .5">{{n.created_at | datePrettify}}</div>
              </div>
            </router-link>
            <div class="dropdown-item plain-link-item">
              <router-link class="plain-link" :to="{name: 'Notification'}">
                {{'notifications.all' | translate}}
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <language-selector class="col nav-item navbar-dropdown"/>
      <div
        class="col nav-item dropdown navbar-dropdown d-flex align-items-center justify-content-center"
        v-dropdown>
        <a class="navbar-text dropdown-toggle d-flex align-items-center justify-content" href="#"
           @click.prevent="closeMenu">
          <span class="avatar-container" :style="{backgroundImage: 'url(' + avatarHref + ')'}">
            <!--<img :src="avatarHref"/>-->
          </span>
          <div v-if="profile" class="ml-1 d-lg-inline-block d-none">
            <div class="text-nowrap ellipsis" style="max-width: 100px">{{profile.name}}</div>
            <small class="text-nowrap">{{'roles.' + profile.role | translate}}</small>
          </div>
        </a>
        <div class="dropdown-menu last">
          <div class="dropdown-menu-content">
            <div class="dropdown-item plain-panel">
              <div>
                <div v-if="profile">{{profile.name}}</div>
                <div v-if="user">
                  <small>{{user.username || user.email}}</small>
                </div>
                <div v-if="profile" class="badge badge-primary">{{'roles.' + profile.role | translate}}</div>
              </div>
            </div>
            <div class="dropdown-separator"></div>
            <div class="dropdown-item plain-link-item">
              <a class="plain-link" :href="ssoHref">{{'Profile Settings' | translate}}</a>
            </div>
            <div class="dropdown-item plain-link-item">
              <a class="plain-link" :href="ssoSwitchHref">{{'Switch Profile' | translate}}</a>
            </div>
            <div class="dropdown-item plain-link-item">
              <a class="plain-link" :href="logoutHref">{{'Logout' | translate}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex';
  import LanguageSelector from './LanguageSelector';
  import moment from 'moment';

  export default {
    name: 'navbar',

    components: {
      LanguageSelector,
    },

    data () {
      return {
        href: window.location.href,
      };
    },

    watch: {
      $route () {
        this.href = window.location.href;
      },
    },

    computed: {
      ...mapGetters([
        'sidebarOpened',
        'toggleWithoutAnimation',
        'config',
        'profile',
        'user',
        'api',
      ]),
      ...mapState({
        notifications: state => state.app.notifications,
      }),
      moment: () => moment,
      env: () => process.env,
      avatarHref () {
        return this.profile && this.profile.avatar
          ? `${this.api.host}${this.api.base}/attachment/${this.profile.avatar}/thumbnail?size=64&gif=1`
          : require('@/assets/icons/avatar-placeholder.png');
      },
      logoutHref () {
        let q = new URLSearchParams();
        q.append('redirect', this.href);
        return this.config.api.host + this.config.api.base + '/sso/logout?' + q.toString();
      },
      ssoHref () {
        let q = new URLSearchParams();
        q.append('role', this.config.allowedRoles.join(','));
        q.append('redirect', this.href);
        return this.config.api.host + '/sso/success?' + q.toString();
      },
      ssoSwitchHref () {
        let q = new URLSearchParams();
        q.append('switch', '1');
        q.append('role', this.config.allowedRoles.join(','));
        q.append('redirect', this.href);
        return this.config.api.host + '/sso/?' + q.toString();
      },
    },

    mounted () {
      this.updateNotifications();
      setInterval(() => {
        this.updateNotifications();
      }, 180 * 1000);
    },

    methods: {
      ...mapActions([
        'closeMenu',
        'toggleSidebar',
        'isToggleWithoutAnimation',
        'updateNotifications',
      ]),
    },
  };
</script>

<style lang="scss">
  @import "../../../sass/_variables.scss";
  @import "~bootstrap/scss/mixins/breakpoints";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";

  .navbar.app-navbar {
    @media print {
      display : none !important;
    }

    .logo {
      height         : 100%;
      padding-top    : $navbar-padding-y;
      padding-bottom : $navbar-padding-y;

      img {
        max-height : 100%;
      }
    }

    .navbar-container {
      width  : 100%;
      height : 100%;
      margin : 0;
    }

    height           : $top-nav-height;
    padding-left     : $nav-padding-left;
    padding-right    : $nav-padding-right;
    background-color : $top-nav-bg;

    .avatar-container {
      display             : inline-block;
      width               : 50px;
      height              : 50px;
      background-color    : white;
      border-radius       : 50%;
      border              : 2px solid $lighter-gray;
      overflow            : hidden;
      background-position : center;
      background-size     : cover;

      img {
        height : 100%;
        width  : 100%;
      }
    }

    .menu-icon-container {
      padding   : 0;
      font-size : $font-size-base;
    }

    .navbar-brand-container {
      position : absolute;
      /*z-index  : 3;*/
      height   : 100%;
      left     : $navbar-brand-container-left;
      top      : 0;
    }

    .nav-item {
      padding : 0;
      height  : 100%;
    }

    .dropdown.navbar-dropdown {
      .dropdown-toggle {
        padding : 0;
        &:after {
          display : none;
        }
      }

      &.show {
        @include media-breakpoint-up(lg) {
          .dropdown-menu {
            left  : auto;
            right : 0;
          }
        }
        &:after {
          position      : absolute;
          bottom        : -$dropdown-show-b;
          right         : calc(50% - 10px);
          width         : 0;
          height        : 0;
          display       : block;
          content       : '';
          border-left   : 10px solid transparent;
          border-right  : 10px solid transparent;
          border-bottom : 10px solid $darkest-gray;
        }
      }

      .dropdown-menu {
        margin-top  : $dropdown-show-b;
        padding-top : 0;
        width       : 100%;
      }

      .dropdown-item {
        height     : auto;
        min-height : $navbar-dd-item-height;
        font-size  : $font-size-base;

        &:hover, &:active, &:focus, &.active {
          outline : none;
        }

        &.plain-link-item {
          color  : $white;
          cursor : pointer;

          &:hover, &:active, &:focus {
            //background : $dropdown-background;
          }

          .plain-link[href] {
            text-decoration : none;
            color           : $brand-primary-light;
          }
        }

        &.plain-panel {
          height : auto;

          > * {
            padding : .5em 0;
          }

          &:hover, &:active, &:focus {
            background : inherit;
          }
        }
      }

      .dropdown-separator {
        height           : 1px;
        background-color : $almost-black;
      }
    }

    .notify {
      position : relative;

      &::after {
        content          : '';
        position         : absolute;
        right            : -6px;
        top              : -6px;
        background-color : $brand-success;
        height           : 12px;
        width            : 12px;
        border-radius    : 50%;
      }
    }

    .i-nav-notification.notify::after {
      right : -4px;
      top   : 0;
    }

    .i-nav-notification {
      position : relative;

      .badge {
        min-width        : auto;
        position         : absolute;
        top              : 0;
        right            : 0;
        transform-origin : center;
        transform        : translate(50%, -50%);
      }
    }

    @include media-breakpoint-down(md) {
      height : $top-mobile-nav-height;
      //padding : $nav-mobile-pt $nav-mobile-padding-h $nav-mobile-pb $nav-mobile-padding-h;

      .navbar-brand-container {
        width  : $nav-mobile-brand-width;
        top    : $nav-mobile-brand-top;
        left   : $nav-mobile-brand-left;
        height : auto;
        .navbar-brand {
          height    : $font-size-smaller;
          padding   : 0;
          font-size : $font-size-smaller;
        }
      }

      .dropdown.navbar-dropdown {
        &.show {
          display : flex;
          &:after {
            bottom  : -$dropdown-mobile-show-b;
            z-index : 2;
          }
          .dropdown-menu {
            margin-top : $dropdown-mobile-show-b;
            left       : auto;
            &.last {
              right : 0;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/navbar/Navbar.vue